
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91id_93ZbGs34ItcyMeta } from "/builds/1tool/storage-management/pages/dashboard/delivery/[id].vue?macro=true";
import { default as indexcsq6aRK9M5Meta } from "/builds/1tool/storage-management/pages/dashboard/delivery/index.vue?macro=true";
import { default as indexOtY9ZZYVKIMeta } from "/builds/1tool/storage-management/pages/dashboard/goods-receipt/index.vue?macro=true";
import { default as indexT3q5FjTaESMeta } from "/builds/1tool/storage-management/pages/dashboard/index.vue?macro=true";
import { default as booked1L2NtNXuV1Meta } from "/builds/1tool/storage-management/pages/dashboard/inventory/booked.vue?macro=true";
import { default as countw4w6RBGfBuMeta } from "/builds/1tool/storage-management/pages/dashboard/inventory/count.vue?macro=true";
import { default as index7jFLXtSYQ2Meta } from "/builds/1tool/storage-management/pages/dashboard/inventory/index.vue?macro=true";
import { default as reviewRvN4uuLdrnMeta } from "/builds/1tool/storage-management/pages/dashboard/inventory/review.vue?macro=true";
import { default as scanEgaMCqFHlbMeta } from "/builds/1tool/storage-management/pages/dashboard/inventory/scan.vue?macro=true";
import { default as sessionLxcxIHqlOLMeta } from "/builds/1tool/storage-management/pages/dashboard/inventory/session.vue?macro=true";
import { default as indexvXeDWxkC2fMeta } from "/builds/1tool/storage-management/pages/dashboard/shipping-labels/index.vue?macro=true";
import { default as indexiZWodo81BGMeta } from "/builds/1tool/storage-management/pages/dashboard/stock-valuation-fifo/index.vue?macro=true";
import { default as indexzoNIkJxGJKMeta } from "/builds/1tool/storage-management/pages/dashboard/stock-valuation/index.vue?macro=true";
import { default as indexVklpuzPVhHMeta } from "/builds/1tool/storage-management/pages/dashboard/undeliverable/index.vue?macro=true";
import { default as indexOx66EjFoXtMeta } from "/builds/1tool/storage-management/pages/dashboard/warehouse-details/index.vue?macro=true";
import { default as indexV68wWAtR8JMeta } from "/builds/1tool/storage-management/pages/index.vue?macro=true";
import { default as indexXVGcIs7pmHMeta } from "/builds/1tool/storage-management/pages/login/index.vue?macro=true";
export default [
  {
    name: "dashboard-delivery-id",
    path: "/dashboard/delivery/:id()",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/delivery/[id].vue")
  },
  {
    name: "dashboard-delivery",
    path: "/dashboard/delivery",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/delivery/index.vue")
  },
  {
    name: "dashboard-goods-receipt",
    path: "/dashboard/goods-receipt",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/goods-receipt/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-inventory-booked",
    path: "/dashboard/inventory/booked",
    meta: booked1L2NtNXuV1Meta || {},
    component: () => import("/builds/1tool/storage-management/pages/dashboard/inventory/booked.vue")
  },
  {
    name: "dashboard-inventory-count",
    path: "/dashboard/inventory/count",
    meta: countw4w6RBGfBuMeta || {},
    component: () => import("/builds/1tool/storage-management/pages/dashboard/inventory/count.vue")
  },
  {
    name: "dashboard-inventory",
    path: "/dashboard/inventory",
    meta: index7jFLXtSYQ2Meta || {},
    component: () => import("/builds/1tool/storage-management/pages/dashboard/inventory/index.vue")
  },
  {
    name: "dashboard-inventory-review",
    path: "/dashboard/inventory/review",
    meta: reviewRvN4uuLdrnMeta || {},
    component: () => import("/builds/1tool/storage-management/pages/dashboard/inventory/review.vue")
  },
  {
    name: "dashboard-inventory-scan",
    path: "/dashboard/inventory/scan",
    meta: scanEgaMCqFHlbMeta || {},
    component: () => import("/builds/1tool/storage-management/pages/dashboard/inventory/scan.vue")
  },
  {
    name: "dashboard-inventory-session",
    path: "/dashboard/inventory/session",
    meta: sessionLxcxIHqlOLMeta || {},
    component: () => import("/builds/1tool/storage-management/pages/dashboard/inventory/session.vue")
  },
  {
    name: "dashboard-shipping-labels",
    path: "/dashboard/shipping-labels",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/shipping-labels/index.vue")
  },
  {
    name: "dashboard-stock-valuation-fifo",
    path: "/dashboard/stock-valuation-fifo",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/stock-valuation-fifo/index.vue")
  },
  {
    name: "dashboard-stock-valuation",
    path: "/dashboard/stock-valuation",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/stock-valuation/index.vue")
  },
  {
    name: "dashboard-undeliverable",
    path: "/dashboard/undeliverable",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/undeliverable/index.vue")
  },
  {
    name: "dashboard-warehouse-details",
    path: "/dashboard/warehouse-details",
    component: () => import("/builds/1tool/storage-management/pages/dashboard/warehouse-details/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/1tool/storage-management/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexXVGcIs7pmHMeta || {},
    component: () => import("/builds/1tool/storage-management/pages/login/index.vue")
  }
]